import React from "react";

import { ReferenciaPlantillaContenido } from "../../../interfaces/ReferenciaPlantillaContenido";
import { formatImageAlt } from "../../../shared/utils/stringUtilities";

import "./cardClub.scss";

interface CardClubProps {
  club: ReferenciaPlantillaContenido
}

const CardClub = (props: CardClubProps) => {
  const { club } = props;

  return (
    <div className="a-card-club">
      {club.imagenPrincipal && <img 
        src={club.imagenPrincipal[0].file.url} 
        alt={club.imagenPrincipal[0].title ? 
          formatImageAlt(club.imagenPrincipal[0].title) : "Imagen club"
        }
        className="a-card-club__image"
      />}
      <div className="a-card-club__black-bg"></div>
      <div className="a-card-club__content">
        <h3 className="a-card-club__content__name">{club.tituloBanner}</h3>
        <div className="a-card-club__content__bottom-texts">
          <p className="a-card-club__content__bottom-texts__location">
            {club.tituloDescripcion}
          </p>
          <p 
            className="a-card-club__content__bottom-texts__cta"
          >
            <span className="icon-plus-circle1"></span>
            Unirme
          </p>
        </div>
      </div>
    </div>
  )
}

export default CardClub;